<script lang="ts" setup>
defineProps<{
  icon: string
}>()
</script>

<template>
  <a
    class="
      flex !size-[44px] min-w-[44px] cursor-pointer items-center justify-center rounded-xl bg-[#f7f7f7]
      p-[10px] md:!size-[56px] md:min-w-[56px]
    "
    href="#"
  >
    <SvgIcon
      class="!size-6 !text-main-green"
      :name="icon"
    />
  </a>
</template>
